<template>
    <div class="item-wrap">
        <div class="item-title-wrap">
            <div class="item-title">{{item.name}}</div>
            <div class="item-status">{{item.status_text}}</div>
        </div>
        <div class="item-desc">{{item.start_time}} 至 {{item.end_time}}</div>
        <div class="item-desc">{{item.area + item.address}}</div>
        <div class="btn-item" @click="_onPressToNavigate('', 'courseParticipant', {id: item.id})">查看报名列表（{{item.enroll_num || 0}}人）</div>
    </div>
</template>
<script>
export default {
    name: "courseRecordItem",
    props:[
        'item', 
    ],
    data() {
        return {
            
        };
    },
    methods: {
        _onBack() {
            this.$router.back();
        },
        
        // 点击跳转
        _onPressToNavigate(pageTitle, path, query) {
            if(pageTitle) {
                query = {
                    ...query,
                    pageTitle,
                }
            }
            this.$router.push({path, query});
        },

        _onPressToWeb(url) {
            if(!url) return;
            window.location.href = url;
        },
    },
};
</script>
<style lang="less" scoped>
.item-wrap {
    padding: 10px;
    border-radius: 3px;
    margin: 10px 15px 0;
    background: #ffffff;

    .item-title-wrap {
        display: flex;
        align-items: center;

        .item-title {
            flex: 1;
            color: #333;
            font-weight: 600;
            font-size: 1.4rem;
        }

        .item-status {
            color: #7181EB;
            padding: 2px 7px;
            font-size: 1.2rem;
            border-radius: 3px;
            background: #F1F3FF;
            border: 1px solid #7181EB;
        }
    }

    .item-desc {
        color: #333;
        line-height: 1.8;
        font-size: 1.3rem;
    }

    .btn-item {
        color: #fff;
        height: 35px;
        display: flex;
        font-size: 15px;
        margin-top: 10px;
        border-radius: 3px;
        align-items: center;
        justify-content: center;
        background: linear-gradient(225deg,#9cb2f4, #6472e8);
    }
}
</style>